import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css"
import DropFileInput from "../../DropFileComponent/DropFileComponent";


const FileInput = ({ id, label, placeholder, value, example, disabled, mandatory, filelimit, md }) => {
    const { handleChange } = useContext(FormContext)
    return (
        <Col md={md} className="pad-trl-10">
        <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
            <DropFileInput
                onFileChange={(files) => handleChange(id, files)}
                fileLimit={filelimit}
                />
            {example!==null?<div id="emailHelp" className="text-muted move-left input-example">Example: {example}</div>:<></>}
        </div>
        </Col>
    )
}

export default FileInput